<mat-toolbar>
  <a aria-label="Homepage" routerLink="/">
    <img class="logo" src="/assets/images/SR_Logo.svg" alt="Swiss Re Logo" />
  </a>
  <div class="header-title-container">
    <span class="header-title">ESG Risk Assessment Tool</span>
  </div>
  <span class="example-spacer"></span>
</mat-toolbar>
